import React from 'react';
import { BlogPostTemplate } from '../components/Blog/BlogPostTemplate';
import blogData from '../data/blog/en/emotional-drain-part-2.json';
import { BlogPostData } from '../types/blog';
export function BlogPostEmotionalDrainPart2() {
  return <BlogPostTemplate content={blogData as BlogPostData} data-id="element-4009" />;
}